import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ModalWrapper from 'components/ModalWrapper';
import CancelIcon from '@mui/icons-material/Cancel';

const Modal = ({ open, setOpen, data }) => {
  const handleClose = () => setOpen(false);

  return (
    <Dialog open={open} onClose={handleClose}>
      <ModalWrapper>
        <CancelIcon className='close-icon' onClick={handleClose} />
        <DialogTitle>Notification</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ textAlign: 'center' }}>
            {data?.notification?.image && (
              <img
                style={{ maxWidth: 200 }}
                src={data?.notification?.image}
                alt='notification'
              />
            )}
            <div
              dangerouslySetInnerHTML={{
                __html: data?.notification?.description,
              }}
            />
          </DialogContentText>
        </DialogContent>
      </ModalWrapper>
    </Dialog>
  );
};

export default Modal;
